import { render, staticRenderFns } from "./CommunitySpace.vue?vue&type=template&id=4538191d&"
import script from "./CommunitySpace.vue?vue&type=script&lang=js&"
export * from "./CommunitySpace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports